// Build an .ics file from chosen rodeo performances and trigger a download.
function pad(n) { return String(n).padStart(2, "0"); }

function parseTime(t) {
  // "6:00 PM" -> {h, m}
  const m = /(\d{1,2}):(\d{2})\s*(AM|PM)/i.exec(t || "");
  if (!m) return { h: 9, m: 0 };
  let h = parseInt(m[1], 10);
  const min = parseInt(m[2], 10);
  const ap = m[3].toUpperCase();
  if (ap === "PM" && h !== 12) h += 12;
  if (ap === "AM" && h === 12) h = 0;
  return { h, m: min };
}

function fmtDT(dateISO, time) {
  const [y, mo, d] = dateISO.split("-").map(Number);
  const { h, m } = parseTime(time);
  return `${y}${pad(mo)}${pad(d)}T${pad(h)}${pad(m)}00`;
}

export function googleCalUrl({ title, dateISO, time, location, details }) {
  const start = fmtDT(dateISO, time);
  const { h, m } = parseTime(time);
  const endH = (h + 2) % 24;
  const [y, mo, d] = dateISO.split("-");
  const end = `${y}${mo}${d}T${pad(endH)}${pad(m)}00`;
  const p = new URLSearchParams({ action: "TEMPLATE", text: title, dates: `${start}/${end}`, location: location || "", details: details || "" });
  return `https://calendar.google.com/calendar/render?${p.toString()}`;
}

export function downloadICS(events, filename = "rodeo-pilot.ics") {
  const lines = ["BEGIN:VCALENDAR", "VERSION:2.0", "PRODID:-//Rodeo Pilot//EN", "CALSCALE:GREGORIAN"];
  events.forEach((e, i) => {
    const start = fmtDT(e.dateISO, e.time);
    const { h, m } = parseTime(e.time);
    const [y, mo, d] = e.dateISO.split("-");
    const end = `${y}${mo}${d}T${pad((h + 2) % 24)}${pad(m)}00`;
    lines.push("BEGIN:VEVENT",
      `UID:rp-${Date.now()}-${i}@rodeopilot`,
      `DTSTAMP:${start}`,
      `DTSTART:${start}`,
      `DTEND:${end}`,
      `SUMMARY:${e.title}`,
      `LOCATION:${e.location || ""}`,
      `DESCRIPTION:${e.details || ""}`,
      "END:VEVENT");
  });
  lines.push("END:VCALENDAR");
  const blob = new Blob([lines.join("\r\n")], { type: "text/calendar" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = filename; a.click();
  URL.revokeObjectURL(url);
}
